import {createFileRoute, useNavigate, useSearch} from '@tanstack/react-router';
import {useCallback, useEffect} from 'react';

import {AuthService} from '~api/auth.service';
import {LoginSearchParams} from '~utils/routeUtil';
import {useTrackEvent} from '~hooks/analytics.hooks';
import {fetchUser, loginAndFetchUser} from '~redux/actions/userActions';
import {useAppDispatch} from '~redux/index';

import {Login} from '~components/login/Login';

export const Route = createFileRoute('/login')({
  component: LoginPage,
  validateSearch: LoginSearchParams.validate,
});

function LoginPage() {
  const trackEvent = useTrackEvent();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {redirect: redirectUrl} = useSearch({from: '/login'});

  const redirectIfLoggedIn = useCallback(async () => {
    if (AuthService.isLoggedIn()) {
      if (redirectUrl && typeof redirectUrl === 'string') {
        await navigate({to: redirectUrl as any});
      }
    }
  }, [redirectUrl, navigate]);

  useEffect(() => {
    const redirect = async () => {
      await redirectIfLoggedIn();
    };
    redirect();
  }, [redirectIfLoggedIn]);

  async function handleLogin(email: string, password: string) {
    await dispatch(loginAndFetchUser(email, password));
    await redirectIfLoggedIn();
    const user = await fetchUser();
    trackEvent('login', {
      userAgent: navigator.userAgent,
      groupId: user?.email.endsWith('maddox.ai') ? `${user?.customer}_internal` : user?.customer,
    });
  }

  return <Login onSubmit={handleLogin} />;
}
